const sortFunc = (a, b, order, dataField, rowA, rowB) => {
  if (order === 'asc') {
    return Number(a) - Number(b);
  }
  return Number(b) - Number(a);
};

export default sortFunc;
